import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { NEWTIRES } from '../constants/testIds';

const POINTS = [
  'Full container load required per order',
  'Select the exact sizes you need for your inventory',
  'Delivery in 30–60 days (overseas warehouse loading & shipping)',
];

export const NewTireLoads = () => (
  <section id="new-tires" data-testid={NEWTIRES.section} className="relative bg-brand-surface py-24 sm:py-32 border-y border-brand-border/60">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
        <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-brand-green bg-brand-bg/60 border border-brand-border rounded-full px-4 py-1.5 mb-5">
          <Sparkles className="w-3.5 h-3.5" />
          New Offering
        </span>
        <h2 className="font-display font-extrabold uppercase tracking-tight text-brand-text text-3xl sm:text-4xl lg:text-5xl max-w-2xl">
          Bulk New Tire Loads
        </h2>
        <p className="mt-5 max-w-2xl text-brand-muted text-base sm:text-lg">
          We now offer great-quality new tires for bulk purchase. We've partnered with a supplier of well-known
          branded tires to ship in bulk directly from the manufacturing warehouse to your location.
        </p>

        <ul className="mt-7 space-y-3 max-w-xl">
          {POINTS.map((p) => (
            <li key={p} className="flex items-start gap-3 text-brand-text text-sm sm:text-base">
              <CheckCircle2 className="w-5 h-5 text-brand-green mt-0.5 shrink-0" />
              <span>{p}</span>
            </li>
          ))}
        </ul>

        <div className="mt-8">
          <a
            href="#order-form"
            data-testid={NEWTIRES.ctaInquire}
            className="inline-flex items-center gap-2 border border-brand-border text-brand-text font-display font-bold uppercase tracking-wide rounded-full px-7 py-3.5 hover:border-brand-amber transition-colors"
          >
            Inquire About New Tire Loads
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);
